import { Fragment } from "react";
import {
  Input,
  Button,
  Switch,
  Select,
  Option,
} from "@material-tailwind/react";
import { FaCopy } from "react-icons/fa";
import "./formBuilder.css";
//Form Elements
import { formEl } from "../constants";

const TextFieldNew = ({
  item,
  index,
  handleValue,
  deleteEl,
  handleRequired,
  handleElType,
  duplicateElement,
  handleSave,
}) => {
  return (
    <Fragment>
      {item.saved ? (
        <>
          <div className="form-group-container relative">
            <div className="mb-4">
              <label className="block text-base font-medium text-gray-700">
                {item.required && "* "}
                {index + 1 + ". " + item.value}
              </label>
              <Input disabled type="text" />
            </div>
            <div className="absolute top-0 right-1 flex justify-end items-center gap-2 buttons-container">
              <Button
                size="sm"
                color="blue-gray"
                onClick={() => handleSave(item.id)}
              >
                Edit
              </Button>
              <Button size="sm" color="red" onClick={() => deleteEl(item.id)}>
                Delete
              </Button>
              <Button
                size="sm"
                color="gray"
                onClick={() => duplicateElement(item.id, item.type)}
              >
                Duplicate
              </Button>
            </div>
          </div>
        </>
      ) : (
        <div className="bg-white border px-3 py-2 border-gray-400 rounded-sm text-sm font-normal text-gray-800 w-full">
          <div className="flex flex-wrap px-2 py-2">
            <div className="w-full md:w-3/4">
              <div className="flex items-center gap-2">
                <label className="text-lg mb-0">Q.{index + 1}.</label>

                <Input
                  label="Enter your question"
                  defaultValue={item.value}
                  onBlur={(e) => handleValue(item.id, e)}
                  required={item.required}
                />
              </div>
            </div>
            <div className="w-full md:w-1/4">
              <Select
                className=" !border-t-blue-gray-2-00 focus:!border-t-gray-900"
                labelProps={{
                  className: "before:content-none after:content-none",
                }}
                value={item.type}
                onChange={(value) => handleElType(item.id, value)}
              >
                {formEl &&
                  formEl.map((el, key) => (
                    <Option key={key} value={el.value}>
                      {el.label}
                    </Option>
                  ))}
              </Select>
            </div>
          </div>

          <hr />
          <div className="flex justify-between items-center mt-2 gap-2">
            <div>
              <Switch
                id={`required-${item.id}`}
                label="Required"
                checked={item.required}
                onChange={() => handleRequired(item.id)}
              />
            </div>
            <div className="flex items-center gap-2">
              <Button
                size="sm"
                variant="outlined"
                color="red"
                onClick={() => deleteEl(item.id)}
              >
                Cancel
              </Button>
              <Button
                disabled={!item.value}
                size="sm"
                className="bg-[#000080]"
                onClick={() => handleSave(item.id)}
              >
                Save
              </Button>
              <Button
                size="sm"
                color="gray"
                onClick={() => duplicateElement(item.id, item.type)}
              >
                <FaCopy className="text-secondary" />
              </Button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default TextFieldNew;
